const CONFIG = {

  
  DEV_API: "https://devapi.taxivaxi.com", //DEV_API

  ////Demo Apis
    MAIN_API: "https://demo.taxivaxi.com", //MAIN_API demo
  BASE_URL : "https://www.nirixak.com/testuapi/api/flights/", //test
//   BASE_URL:"https://92tvxz7r-3000.inc1.devtunnels.ms/api/flights/", //local
  ASSIGN_API:"https://demo.taxivaxi.com/api/flights/assignSbtCotravFlightBookingNew", //demo

  //Live Apis
// MAIN_API: "https://corporate.taxivaxi.com",  //Live
//   BASE_URL: "https://www.nirixak.com/uapi/api/flights/", //live
//  ASSIGN_API:"https://corporate.taxivaxi.com/api/flights/assignSbtCotravFlightBookingNew", //Live

// };

// const CONFIG = {
//     MAIN_API: "https://demo.taxivaxi.com",        //MAIN_API
//     DEV_API: "https://demodevapi.taxivaxi.com"          //DEV_API
};
export default CONFIG;
